import Button from "@mui/material/Button";
import {
  ThemeProvider,
  alpha,
  createTheme,
  getContrastRatio,
  useTheme as useMuiTheme,
} from "@mui/material/styles";
import * as React from "react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { isRTL } from "../../../i18n/config";
import { useAppTheme } from "../../../theme/useTheme";

function GeneralButton({
  variant,
  value,
  onClickEvent,
  color,
  className,
  size,
  disabled,
  title,
  startIcon,
  form,
  hidden,
  endIcon,
  style
}) {
  const { i18n } = useTranslation();
  const isRtlMode = isRTL(i18n.language);
  const { theme: appTheme, mode } = useAppTheme();
  const muiTheme = useMuiTheme();
  const [customTheme, setCustomTheme] = useState(null);
  
  useEffect(() => {
    if (color) {
      const customColorBase = color;
      const customColorMain = alpha(customColorBase, 0.7);
      
      // Create theme that respects the app's theme mode
      const themeCreated = createTheme({
        ...muiTheme,
        direction: isRtlMode ? "rtl" : "ltr",
        palette: {
          ...muiTheme.palette,
          mode: mode,
          customColor: {
            main: customColorMain,
            light: alpha(customColorBase, 0.5),
            dark: alpha(customColorBase, 0.9),
            contrastText:
              getContrastRatio(customColorMain, "#fff") > 4.5 ? "#fff" : "#111",
          },
        },
      });
      setCustomTheme(themeCreated);
    } else {
      setCustomTheme(null);
    }
  }, [color, mode, muiTheme]);

  const buttonClassName = `${className || ""} px-3 general-button ${
    typeof value !== "string" || value.length <= 7
      ? "submit_button_width"
      : ""
  }`;

  return customTheme ? (
    <ThemeProvider theme={customTheme}>
      <Button
        className={buttonClassName}
        variant={variant}
        color="customColor"
        onClick={onClickEvent}
        type={onClickEvent ? "button" : "submit"}
        size={size}
        title={title}
        disabled={disabled}
        startIcon={startIcon}
        endIcon={endIcon}
        form={form}
        hidden={hidden}
        sx={{
          whiteSpace: "nowrap !important",
          "& .MuiButton-startIcon": {
            marginRight: isRtlMode ? "-4px" : "8px",
            marginLeft: isRtlMode ? "8px" : "-4px",
          },
          "& .MuiButton-endIcon": {
            marginRight: isRtlMode ? "8px" : "-4px",
            marginLeft: isRtlMode ? "-4px" : "8px",
          },
          ...style,
        }}
      >
        {value}
      </Button>
    </ThemeProvider>
  ) : (
    <Button
      className={buttonClassName}
      variant={variant}
      color="primary"
      onClick={onClickEvent}
      type={onClickEvent ? "button" : "submit"}
      size={size}
      title={title}
      disabled={disabled}
      startIcon={startIcon}
      form={form}
      hidden={hidden}
      endIcon={endIcon}
      sx={{
        whiteSpace: "nowrap !important",
        "& .MuiButton-startIcon": {
          marginRight: isRtlMode ? "-4px" : "8px",
          marginLeft: isRtlMode ? "8px" : "-4px",
        },
        "& .MuiButton-endIcon": {
          marginRight: isRtlMode ? "8px" : "-4px",
          marginLeft: isRtlMode ? "-4px" : "8px",
        },
        ...style,
      }}
    >
      {value}
    </Button>
  );
}
export default GeneralButton;
